<template>
  <div>
    <vx-card heading-size="h1" title="Add Student">
      <p>
        Enter the student's First Name, Surname, Email Address, give them a Password and select
        their Year or Group - then click the "Save Changes" button.<br /><br />

        You can then give them their login details so they can log into the Virtual Job Experience
        website. It will also enable you to view and edit all their details and view all their Job
        Experiences.
      </p>
      <!-- Info -->
      <vs-input
        class="w-full"
        label-placeholder="First Name"
        v-model="name"
        v-validate="'required'"
        name="name"
      ></vs-input>
      <span class="text-danger text-sm" v-show="errors.has('name')">{{
        errors.first('name')
      }}</span>

      <vs-input
        class="w-full mt-8"
        label-placeholder="Last Name"
        v-model="surname"
        v-validate="'required'"
        name="surname"
      ></vs-input>
      <span class="text-danger text-sm" v-show="errors.has('surname')">{{
        errors.first('surname')
      }}</span>

      <vs-input
        class="w-full mt-8"
        label-placeholder="Email"
        v-model="email"
        v-validate="'required|email'"
        name="email"
      ></vs-input>
      <span class="text-danger text-sm" v-show="errors.has('email')">{{
        errors.first('email')
      }}</span>

      <vs-input
        ref="password"
        type="password"
        class="w-full mt-8"
        label-placeholder="Password"
        v-model="password"
        v-validate="'required'"
        name="password"
      ></vs-input>
      <span class="text-danger text-sm" v-show="errors.has('password')">{{
        errors.first('password')
      }}</span>

      <vs-input
        type="password"
        class="w-full mt-8 mb-3"
        label-placeholder="Confirm Password"
        v-model="confirm_password"
        v-validate="'confirmed:password'"
        name="confirm_password"
        data-vv-as="password"
      ></vs-input>
      <span class="text-danger text-sm" v-show="errors.has('confirm_password')">{{
        errors.first('confirm_password')
      }}</span>

      <select class="defaultselect w-full" v-model="year" aria-label="Year Group">
        <option
          :key="index"
          :value="item.id"
          v-for="(item, index) in student_groups"
          :selected="item.id == year"
        >
          {{ item.name }}
        </option>
      </select>
      <!-- Save & Reset Button -->
      <div class="flex flex-wrap items-center justify-end">
        <form @submit.prevent="validateForm">
          <vs-button class="ml-auto mt-2" button="submit">Save Changes</vs-button>
        </form>

        <vs-alert
          class="mt-5"
          :color="alertStatus"
          :title="alertTitle"
          active="true"
          v-if="showAlert"
        >
          <span v-html="alertMessage"></span>
        </vs-alert>
      </div>
    </vx-card>

    <vx-card title="Bulk Student Account Creation">
      <p>
        <a href="https://www.careertools.com.au/public_files/student_import.csv" target="_blank"
          >Right click here</a
        >
        to download a sample CSV file. It shows you the columns required, ie: First Name, Last Name,
        Email (also their login username), Password and Year Group.
      </p>
      <br />
      <p>
        You can just replace the first row with your own student details and add as many more as you
        need to.
      </p>
      <br />
      <p>The Year/Groups you can enter are (in this exact format):</p>
      <br />
      <p>
        Year 7<br />
        Year 8<br />
        Year 9<br />
        Year 10<br />
        Year 11<br />
        Year 12
      </p>

      <input
        type="file"
        id="bulk-student-file"
        ref="file"
        v-on:change="handleFileUpload()"
        style="display: none"
      />
      <button @click="$refs.file.click()" class="btn btn-secondary btn-size-medium mt-5">
        Select File
      </button>
      <p class="my-3">
        <small v-if="file">{{ file.name }}</small>
      </p>
      <vs-button
        color="primary"
        icon-pack="feather"
        icon="icon-upload"
        type="relief"
        v-on:click="submitFile()"
        class="my-4"
        >Import Students</vs-button
      >

      <vs-alert
        class="mt-5"
        color="success"
        title="Bulk Import Successful"
        active="true"
        v-if="showBulkAlert"
      >
        {{ bulkAlertMessage }}
      </vs-alert>
      <vs-collapse v-if="showBulkAlert">
        <vs-collapse-item>
          <div slot="header">View Added Students</div>
          <span v-html="bulkAddedStudents"></span>
        </vs-collapse-item>

        <vs-collapse-item>
          <div slot="header">View Duplicate Students</div>
          <span v-html="bulkDuplicateStudents"></span>
        </vs-collapse-item>
      </vs-collapse>
    </vx-card>
  </div>
</template>

<script>
import studentMixin from '@/mixins/student';
import { Validator } from 'vee-validate';
import theApi from '@/mixins/theApi';
import store from '@/store/store';
const dict = {
  custom: {
    surname: {
      required: 'The last name field is required',
    },
    confirm_password: {
      confirmed: "The password confirmation doesn't match",
    },
  },
};

// register custom messages
Validator.localize('en', dict);

export default {
  computed: {
    teacherAccessType() {
      return store.getters['authTeacher/accessType'];
    },
  },
  data() {
    return {
      student_groups: studentMixin.methods.getGroups(),
      name: '',
      surname: '',
      email: '',
      password: '',
      confirm_password: '',
      year: '',
      showAlert: false,
      alertStatus: 'success',
      alertMessage: '',
      alertTitle: 'Success',

      file: '',
      showBulkAlert: false,
      bulkAlertMessage: '',
      bulkAddedStudents: '',
      bulkDuplicateStudents: '',
    };
  },
  methods: {
    validateForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitForm();
        }
      });
    },
    async submitForm() {
      const formData = new FormData();
      formData.append('student_name', this.name);
      formData.append('student_surname', this.surname);
      formData.append('student_email', this.email);
      formData.append('password', this.password);
      formData.append('confirm_password', this.confirm_password);
      formData.append('student_group', this.year);

      theApi.methods
        .makeCall(false, 'students/create', 'post', formData, 'Student added successfully.', true)
        .then(
          () => {},
          () => {},
        );
    },
    submitFile() {
      let formData = new FormData();
      formData.append('file', this.file);

      theApi.methods
        .makeCall(
          false,
          'students/bulk_add',
          'post',
          formData,
          'Students added successfully.',
          true,
        )
        .then(
          () => {},
          () => {},
        );
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
  },
  mounted() {
    if (this.teacherAccessType != 2) {
      this.$router.push('/teacher/dashboard');
    }
  },
  mixins: [studentMixin],
};
</script>
